export default ({ fill = "#111928", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_floorplan_icon)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 1C1.22386 1 1 1.22386 1 1.5V14.5C1 14.7761 1.22386 15 1.5 15H6.93333V10H4.5C4.22386 10 4 9.77614 4 9.5C4 9.22386 4.22386 9 4.5 9H7.43333H7.93333H10.1665C10.4426 9 10.6665 9.22386 10.6665 9.5C10.6665 9.77614 10.4426 10 10.1665 10H7.93333V15H14.5C14.7761 15 15 14.7761 15 14.5V10H12.5667C12.2905 10 12.0667 9.77614 12.0667 9.5C12.0667 9.22386 12.2905 9 12.5667 9H15V1.5C15 1.22386 14.7761 1 14.5 1H11.5C11.2239 1 11 0.776142 11 0.5C11 0.223858 11.2239 0 11.5 0H14.5C15.3284 0 16 0.671573 16 1.5V14.5C16 15.3284 15.3284 16 14.5 16H7.43333H1.5C0.671573 16 0 15.3284 0 14.5V1.5C0 0.671573 0.671573 0 1.5 0H6.63795C6.98885 0 7.32865 0.123024 7.59823 0.347668L10.3201 2.61589C10.5322 2.79267 10.5609 3.10795 10.3841 3.32009C10.2073 3.53223 9.89205 3.56089 9.67991 3.38411L6.95804 1.11589C6.86818 1.04101 6.75492 1 6.63795 1H1.5Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_floorplan_icon">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
